import { z } from 'zod'
import {
  requiredString,
  optionalString,
  optionalBoolean,
  optionalFile,
  createResourceSchema
} from './common'

export const eventTypeSchema = createResourceSchema({
  name: requiredString('Name'),
  icon: optionalString,
  tagline: optionalString,
  description: optionalString,
  active: optionalBoolean,
  image: optionalFile,
  seo_title: optionalString,
  seo_description: optionalString,
  package_ids: z.array(z.string()).optional()
})
